import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    constraints: {
      min: {
        inclusive: false,
        value: 0,
      },
    },
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Space is functionalized based on the total weight for the unit divided by the weight for this entry',
    isOptional: false,
    name: 'Weight',
    partialId: PartialId.Standard.create('weight'),
    type: core.common.value.types.Intrinsic.Decimal,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
